import React, { useEffect } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";

export const Widget = (props: any) => {
  return (
    <React.Fragment>
      {props.data.map((item: any, key: string) => (
        <Col sm={6} md={4} xl={3} key={key}>
          <Card className={"card-animate " + item.cardColor}>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="fw-medium text-muted text-truncate mb-0 fs-16">
                    {item.label}
                  </p>
                  <p className="text fw-small text-muted text-truncate mb-0 mt-1">
                    {item.description}
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-4">
                <div>
                  <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                    <span className="counter-value" data-target="559.25">
                      <CountUp
                        start={0}
                        end={item.counter}
                        duration={4}
                        decimals={item.decimals}
                      />
                    </span>
                    {item.postfix && <span>{item.postfix}</span>}
                  </h4>
                  <div
                    style={{
                      visibility: item.link === "null" ? "hidden" : "visible",
                    }}
                  >
                    <Link to={item.link} className="text-decoration-underline">
                      {item.linkCaption}
                    </Link>
                  </div>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span
                    className={"avatar-title rounded fs-3 bg-" + item.bgcolor}
                  >
                    {item.icon}
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </React.Fragment>
  );
};
